import React from 'react';
import { theme } from '../config/theme';

const styles = {
    modalOverlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(17, 24, 39, 0.8)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 2000,
    },
    modalContent: {
        backgroundColor: theme.colors.background,
        padding: '2rem',
        borderRadius: '8px',
        width: '90%',
        maxWidth: '600px',
        maxHeight: '80vh',
        overflowY: 'auto',
        boxShadow: theme.shadows.soft,
    },
    modalTitle: {
        fontFamily: theme.typography.titleFamily,
        fontSize: '1.5rem',
        color: theme.colors.primary,
        margin: '0 0 1rem 0',
    },
    commentContent: {
        fontFamily: theme.typography.fontFamily,
        fontSize: '1rem',
        color: theme.colors.secondary,
        whiteSpace: 'pre-wrap', // Preserve line breaks and spaces
        wordWrap: 'break-word',
    },
    modalActions: {
        marginTop: '2rem',
        display: 'flex',
        justifyContent: 'flex-end',
    },
    button: {
        fontFamily: theme.typography.fontFamily,
        backgroundColor: theme.colors.primary,
        color: theme.colors.textPrimary,
        border: 'none',
        borderRadius: theme.borderRadius,
        padding: '0.75rem 1.5rem',
        fontSize: '0.9rem',
        fontWeight: '600',
        cursor: 'pointer',
        transition: 'background-color 0.2s',
    },
};

const CommentModal = ({ isOpen, onClose, title, content }) => {
    if (!isOpen) {
        return null;
    }

    return (
        <div style={styles.modalOverlay} onClick={onClose}>
            <div style={styles.modalContent} onClick={(e) => e.stopPropagation()}>
                <h3 style={styles.modalTitle}>{title}</h3>
                <p style={styles.commentContent}>{content}</p>
                <div style={styles.modalActions}>
                    <button onClick={onClose} style={styles.button}>Cerrar</button>
                </div>
            </div>
        </div>
    );
};

export default CommentModal;
